import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler,Nav, NavItem, NavLink } from 'reactstrap';
import "./navbar.css";
import {Link,useHistory} from 'react-router-dom';
import Title from '../../images/title.png'
import Logo from '../../images/logo2.png'

const Example = (props) => {
  const [collapsed, setCollapsed] = useState(true);  
  const toggleNavbar = () => setCollapsed(!collapsed);

  let history = useHistory()

  const cleansStorage = () => {
    sessionStorage.removeItem(`position`)
}

  const logOut = (e) => {
    e.preventDefault()
    localStorage.removeItem('userToken')
    localStorage.removeItem('userId')
    localStorage.removeItem('userPriv')
    history.push(`/`)
  }

  const loginRegLink = (
    <ul className="navbar-nav">
      <li className="nav-item">
        <Link to="/login" className="nav-link">
          Login
            </Link>
      </li>
    </ul>
  )
  const userLink = (
    <ul className="navbar-nav">
      <li className="nav-item">
        <a href="" onClick={logOut} className="nav-link">
          Logout
            </a>
      </li>
    </ul>
  )
  
  return (

    <div className="bar">
      <Navbar color="faded" light>  

      <Link link to="/"> <img className='logo-calanque' src={Logo} alt="logo CMQ"/></Link>
      
      <Link link to="/" ><h1 className="titre-navbar" ><img src={Title} width='140  vw' alt="title"/></h1></Link>

      <div className="burger-menu">
        <NavbarToggler onClick={toggleNavbar}  className="logo-menu" />
      </div>
  
      <Collapse isOpen={!collapsed} navbar>  
        
             <Nav navbar>   
      <div className="all-items">          
            <NavItem>
          <NavLink onClick={() =>  cleansStorage()} tag={Link} to="/monProfil">Profil</NavLink>
          </NavItem>

          <NavItem>
          <NavLink onClick={() =>  cleansStorage()} tag={Link} to="/listEvent">Évènements à venir</NavLink>
          </NavItem>
          
          {localStorage.userPriv === '0' || localStorage.userPriv === undefined ? 
          null : 
          <NavItem>
          <NavLink onClick={() =>  cleansStorage()} ><a className="linkNav" href="https://zealous-wozniak-192b73.netlify.com">Administrateur</a></NavLink>
          </NavItem>}
          
          {localStorage.userToken ? userLink : loginRegLink}

       </div>       
           </Nav>  
                
             </Collapse>
       
            
        </Navbar>
     </div> 
      );
}

export default Example;